import React from "react";

const IdpHeader = ({preferenceStatus, classToggle, isLocation}) => {
  return (
    <header>
      <div className="head">
        <div className="container_blk">
            <div className="idp_logo">
              <img src={require("../../assets/images/logo.png")} alt="" />
            </div>
            <div className="content_blk">
            {preferenceStatus == 0 &&<>
                <h1 className="page_heading">Select Targeted exams</h1>
                <p className="idp_breif">Choose the <strong>EXAMS</strong> you can appear for based on your profile and get regular updates + Previous Years papers, E Books and Mock tests to boost your preparation</p>
            </>}
            {preferenceStatus == 1 &&<>
                <h1 className="page_heading">Select Target {isLocation && 'State and'} Colleges</h1>
                {isLocation && <p className="idp_breif">Select your preferred states where you wish to study</p>}
            </>}
            </div>
        </div>
      </div>
      <div className={`progressDiv ${classToggle}`}> 
        <span className="overProgress">
          <span className="widthProgrees"></span>
        </span>
        <span className="progressNumber step1"> 1</span>
        <span className="progressNumber step2">2</span>
      </div>
    </header>
  );
};

export default IdpHeader